import { useQuery } from "@tanstack/react-query";
import { supabase } from "../../lib/supabase/client";
import { defaultAsterSettings, type AsterSettings } from "./types";

export function normalizeAsterSettingsLanguage(settings: Partial<AsterSettings>) {
  return Object.fromEntries(
    Object.entries(settings).map(([key, value]) => [
      key,
      typeof value === "string" ? value.replaceAll("Learning Center", "Star University") : value,
    ]),
  ) as Partial<AsterSettings>;
}

export function useAsterSettings() {
  return useQuery({
    queryKey: ["public-setting", "aster"],
    staleTime: 60_000,
    queryFn: async () => {
      if (!supabase) return defaultAsterSettings;
      const { data, error } = await supabase.rpc("public_site_setting", {
        setting_key: "aster",
      });
      if (error || !data) return defaultAsterSettings;
      return {
        ...defaultAsterSettings,
        ...normalizeAsterSettingsLanguage(data as Partial<AsterSettings>),
      };
    },
  });
}
